module.exports = __webpack_public_path__ + "img/logo.edbdaf3c.jpg";